export const encode = (v) => {
  return btoa(encodeURIComponent(v));
};

export const decode = (v) => {
  return decodeURIComponent(atob(v));
};
